import {autoserializeAs, autoserializeAsArray} from "dcerialize";
import type {IPaginated} from "../IPaginated";
import {Reference} from "./Reference";

export class References<TReference extends Reference = Reference> implements IPaginated<TReference> {
  @autoserializeAsArray(() => Reference)
  public readonly entries: readonly TReference[];
  @autoserializeAs(() => Number)
  public readonly total: number;
}
